/**
 * Функция для склонения существительных.
 *
 * @param {number} number Число, используемое для склонения.
 * @param {Array} titles Массив со склонениями слова.
 *                      По умолчанию 3 варианта. (['тест', 'теста', 'тестов'])
 *                      Для en-US - 2 варианта. (['test', 'tests'])
 * @param {string} locale Язык.
 * @returns {string} Слово в нужном склонении.
 */
export const format = (number, titles, locale = '') => {
  switch (locale) {
    case 'en-US':
      if (number > 1) {
        return titles[1]
      }
      return titles[0]
    default:
      let cases = [2, 0, 1, 1, 1, 2]
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
  }
}

/**
 * Склонение окончаний в зависимости от типа упаковки товара.
 * @param {number} number
 * @param {Array} forms  Массив из трёх элементов:
 *    элемент 0 - для числа 1;
 *    элемент 1 - для чисел меньших чем 10 и больших чем 20 и заканчивающихся
 *        на 2, 3, и 4;
 *    элемент 2 - все остальные числа.
 * @param {number} unitId id типа упаковки.
 * @returns {string} нужный элемент
 */
export const getRussianDeclension = function (number, forms, unitId) {
  // все типы упаковок мужского рода.
  let unitsOfMenGender = [73, 75, 82, 88]
  if (/1[1-4]$/.test(number)) {
    return forms[2]
  }
  if (/[2-4]$/.test(number)) {
    return forms[1]
  }
  if (/1$/.test(number)) {
    if (unitsOfMenGender.indexOf(unitId) !== -1) {
      return ''
    }
    return forms[0]
  }

  return forms[2]
}
